import { render, staticRenderFns } from "./editor_novel.vue?vue&type=template&id=9fdedf68&scoped=true"
import script from "./editor_novel.vue?vue&type=script&lang=js"
export * from "./editor_novel.vue?vue&type=script&lang=js"
import style0 from "./editor_novel.vue?vue&type=style&index=0&id=9fdedf68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdedf68",
  null
  
)

export default component.exports